export default __webpack_public_path__ + "static/media/home.849d8fac.svg";